import flatten from 'flat';
import account from './fr-FR/account';
import organization from './fr-FR/organization';

export default flatten({
  ...account,
  ...organization,
});
